"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.del = del;
exports.get = get;
exports.patch = patch;
exports.post = post;
exports.put = put;
var _fetch = _interopRequireWildcard(require("@godaddy/fetch"));
var _diagnostics = _interopRequireDefault(require("diagnostics"));
var _querystringify = _interopRequireDefault(require("querystringify"));
var _jsonp = _interopRequireDefault(require("jsonp"));
var _ripOut = _interopRequireDefault(require("rip-out"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const log = (0, _diagnostics.default)('request');

/**
 * Output a deprecation warning to the console.
 * 
 * @param {String} method The method that is deprecated.
 * @private
 */
function deprecated(method) {
  if (process.env.NODE_ENV !== 'production' && !deprecated[method + 'Warned']) {
    console.log(`Deprecated: Use native fetch instead of @godaddy/request's ${method} method`);
    console.trace();
    deprecated[method + 'Warned'] = true;
  }
}

/**
 * Safely stringify an object into JSON and log on error
 *
 * @param {Object} obj An object to stringify into JSON.
 * @returns {String} A JSON string representing obj.
 * @private
 */
function jsonstringify(obj) {
  try {
    return JSON.stringify(obj);
  } catch (error) {
    log(error.message);
  }
}

/**
 * @callback RequestCallback
 * @param {Error} [err] Error, if any
 * @param {any} [data] Data returned
 */
/**
 * Send the request and process response.
 *
 * @param {String} url URI to request.
 * @param {Object} [options] Configuration.
 * @param {RequestCallback} done Completion callback.
 * @returns {Request} Request instance.
 * @private
 */
function send(url, options, done) {
  // eslint-disable-line max-statements, complexity
  if (typeof options === 'function') {
    done = options;
    options = {};
  }
  let controller = options.controller;

  // Cautiously enhance functionality to abort fetch
  if (!controller && typeof _fetch.AbortController !== 'undefined') {
    controller = new _fetch.AbortController();
  }

  // Provide backwards compatibility for internal configuration of requests,
  // see https://github.com/unshiftio/requests/blob/master/index.js#L102.
  options.mode = options.mode || 'cors';
  options.credentials = options.credentials || 'include';
  options.timeout = options.timeout || 30000;
  url = url + _querystringify.default.stringify(options.query || {}, true);
  if (options.jsonp) {
    return (0, _jsonp.default)(url, options, done);
  }
  if (options.body && typeof options.body !== 'string') {
    options.body = jsonstringify(options.body);
  }
  if (typeof options.timeout === 'number' && controller) {
    setTimeout(controller.abort.bind(controller), options.timeout);
    options.signal = controller.signal;
  }

  //
  // Delete properties that should not be passed to the `window.Request` constructor.
  //
  options = (0, _ripOut.default)(options, 'timeout', 'query', 'controller');
  const request = new _fetch.Request(url, options);
  (0, _fetch.default)(request).then(handleResponse).then(content => {
    done(null, content);
  }).catch(done);
  return {
    controller,
    request
  };
}

/**
 * Extract the method that should be used for reading content from the content-type.
 *
 * @param {string} type Content type
 * @returns {string} method
 * @private
 */
function getMethod(type) {
  if (type && ~type.indexOf('application/json')) return 'json';
  if (type && ~type.indexOf('text/')) return 'text';
  return 'blob';
}

/**
 * Handles the response of the fetch request
 *
 * @param {Response} response Response from the request
 * @returns {Promise} Content or Error from the response
 * @private
 */
function handleResponse(response) {
  const method = getMethod(response.headers.get('content-type'));
  if (response.status >= 400) {
    const error = new Error(response.statusText);
    error.status = response.status;
    return Promise.reject(error);
  }
  return response[method]();
}

/**
 * Execute DELETE request
 *
 * @param {String} url URI to request.
 * @param {Object} [options] Configuration.
 * @param {RequestCallback} done Completion callback.
 * @returns {requests} Requests instance.
 * @public
 */
function del(url, options, done) {
  deprecated('del');
  return send(url, _objectSpread(_objectSpread({}, options), {}, {
    method: 'DELETE'
  }), done);
}

/**
 * Execute GET request
 *
 * @param {String} url URI to request.
 * @param {Object} [options] Configuration.
 * @param {RequestCallback} done Completion callback.
 * @returns {requests} Requests instance.
 * @public
 */
function get(url, options, done) {
  deprecated('get');
  return send(url, options, done);
}

/**
 * Execute PATCH request
 *
 * @param {String} url URI to request.
 * @param {Object} data Data to send with request.
 * @param {Object} [options] Configuration.
 * @param {RequestCallback} done Completion callback.
 * @returns {requests} Requests instance.
 * @public
 */
function patch(url, data, options, done) {
  if (typeof options === 'function') {
    done = options;
    options = {};
  }
  deprecated('patch');
  return send(url, _objectSpread(_objectSpread({}, options), {}, {
    method: 'PATCH',
    body: data
  }), done);
}

/**
 * Execute POST request
 *
 * @param {String} url URI to request.
 * @param {Object} data Data to send with request.
 * @param {Object} [options] Configuration.
 * @param {RequestCallback} done Completion callback.
 * @returns {requests} Requests instance.
 * @public
 */
function post(url, data, options, done) {
  if (typeof options === 'function') {
    done = options;
    options = {};
  }
  deprecated('post');
  return send(url, _objectSpread(_objectSpread({}, options), {}, {
    method: 'POST',
    body: data
  }), done);
}

/**
 * Execute PUT request
 *
 * @param {String} url URI to request.
 * @param {Object} data Data to send with request.
 * @param {Object} [options] Configuration.
 * @param {RequestCallback} done Completion callback.
 * @returns {requests} Requests instance.
 * @public
 */
function put(url, data, options, done) {
  if (typeof options === 'function') {
    done = options;
    options = {};
  }
  deprecated('put');
  return send(url, _objectSpread(_objectSpread({}, options), {}, {
    method: 'PUT',
    body: data
  }), done);
}
var _default = exports.default = {
  del,
  get,
  patch,
  post,
  put
};